import { orchestrator } from 'satcheljs';
import {
    updateChildOptionIsShown,
    expandParentOption,
    updateParentOptionIsExpanded,
} from '../actions/parentOptionIsExpandedActions';

orchestrator(expandParentOption, ({ viewState, parentOption, parentIsExpanded }) => {
    updateParentOptionIsExpanded(viewState, parentOption, parentIsExpanded);

    for (let child of parentOption.children) {
        updateChildOptionIsShown(viewState, child, parentOption.isExpanded);
    }
});
